import { render, staticRenderFns } from "./MoviesDisplay.vue?vue&type=template&id=4af66826&scoped=true&"
import script from "./MoviesDisplay.vue?vue&type=script&lang=js&"
export * from "./MoviesDisplay.vue?vue&type=script&lang=js&"
import style0 from "./MoviesDisplay.vue?vue&type=style&index=0&id=4af66826&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af66826",
  null
  
)

export default component.exports